import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectApplyingNotificationIds,
  selectError,
  selectHasUnseen,
  selectLoading,
  selectNotifications,
  selectUnreadCounts,
} from './notification.selectors';

@Injectable({ providedIn: 'root' })
export class NotificationSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly notifications = this._store.selectSignal(selectNotifications);

  public readonly unreadCounts = this._store.selectSignal(selectUnreadCounts);

  public readonly hasUnseen = this._store.selectSignal(selectHasUnseen);

  public readonly loading = this._store.selectSignal(selectLoading);

  public readonly error = this._store.selectSignal(selectError);

  public readonly applyingNotificationIds = this._store.selectSignal(
    selectApplyingNotificationIds,
  );
}
